import React, { useCallback, useRef } from 'react'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import JoditEditor from "jodit-react";
import { ToastContainer } from 'react-toastify';
import Spinner from '../../Spinner/spinner';
import UseAddCampaign from '../hooks/useAddCampaign';
import { debounce } from 'lodash';
const AddCampaign = () => {
  const {
    id,
    editor,
    spinner,
    errors,
    content,
    config,
    handleSave,
    navigate,
    setContent,
    setErrors,
  } = UseAddCampaign()

  const contentRef = useRef(content);
  contentRef.current = content;
  const debouncedOnChange = useCallback(
    debounce((newContent) => {
      setContent((prev) => ({ ...prev, template: newContent }));
      setErrors((prev) => ({ ...prev, template: '' }));
    }, 1000),
    []
  );
  return (
    <>
      <ToastContainer />
      <section>
        <div className="cus-padd cusheight">
          {spinner && <Spinner />}
          <header>
            <h2 className='page-tittle d-flex align-items-center'>
              <ChevronLeftIcon sx={{ fontSize: "30px" }} className='cursor' onClick={() => navigate(-1)} /> {id ? 'Edit' : 'Add'} Template
            </h2>
            <hr />
          </header>
          <div className="row">
            <div className="col-md-12">
              <label htmlFor="recipient-name" className="col-form-label">Subject*</label>
              <input type="text" className="form-control"
                id="recipient-name"
                name='subject'
                value={content?.subject}
                onChange={(e) => { setContent((pre) => ({ ...pre, subject: e.target.value })); setErrors((pre) => ({ ...pre, subject: '' })) }}
              />
              {errors?.subject && <div style={{ color: "red", fontSize: "13px" }}> {errors?.subject} </div>}

            </div>
            <div className="col-md-12 mt-3">
              <label htmlFor="recipient-name" className="col-form-label">Template*</label>
              <JoditEditor
                ref={editor}
                value={content?.template}
                config={config}
                // onBlur={(newContent) => { setContent((pre) => ({ ...pre, template: newContent })) }}
                // onChange={(newContent) => { setContent((pre) => ({ ...pre, template: newContent })); setErrors((pre) => ({ ...pre, template: '' })) }}
                onChange={(newContent) => {
                  contentRef.current.template = newContent; // Update ref value immediately
                  debouncedOnChange(newContent); // Call debounced function
                }}
              />
              {errors?.template && <div style={{ color: "red", fontSize: "13px" }}> {errors?.template}  </div>}
              <div className='my-3'>
                <button type="submit" className="btn btn-primary col-0" onClick={() => handleSave()}>{id ? 'Update' : 'Submit'}</button>
              </div>
            </div>
          </div>


        </div>
      </section>
    </>
  )
}

export default AddCampaign